import { ca } from '@cian/analytics';

import { IJsonQuery } from '../../../../packages/api-models/common/json_query';

interface ITrackAnalyticsArgs {
  queryString: string;
  jsonQuery: IJsonQuery | null;
}

export const trackEmptyListingShow = ({ queryString, jsonQuery }: ITrackAnalyticsArgs) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'informer',
    action: 'show',
    label: 'empty_listing',
    page: { pageType: 'ListingHybrid', siteType: 'mobile', queryString },
    sc: jsonQuery,
  });
};
